import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import {
	gridColumnGap,
	gridFull,
	resetFirstLastChildMargins,
} from '@/css/resources/placeholders.css';
import { breakpoints } from '@/css/resources/variables.css';
import { fluidValues, fluidMargin } from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj({
		'.supt-listAccordions__list': cssObj(
			fluidMargin(styles?.margin),
			fluidValues('gap', styles?.grid?.gap?.[0], styles?.grid?.gap?.[1]),
			{
				'+ .supt-listAccordions__list': cssObj({
					[`@media (max-width: calc(${breakpoints.tablet} - 1px))`]: {
						marginTop: '0 !important',
					},
				}),
			}
		),
	});

const getStyles = (styles) =>
	css(getDynamicStyles(styles), gridColumnGap, {
		display: 'grid',

		/* grid layout and behaviour */
		gridTemplateColumns:
			'[grid-start] 1fr [content-start] 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr [content-end] 1fr [grid-end]',

		gridAutoRows: 'auto',
		gridTemplateRows: 'auto',

		alignItems: 'flex-start',

		'.supt-listAccordions__list': cssObj(gridFull, {
			display: 'grid',

			[`@media (min-width: ${breakpoints.tablet})`]: cssObj(
				resetFirstLastChildMargins,
				{
					gridColumn: 'span 6',
				}
			),

			'&:first-child > *:first-child': {
				marginTop: '0 !important',
			},
		}),
	});

// edit
const getEditGlobalStyles = () =>
	cssObj({
		'.wp-block[data-type="supt/list-accordions"] .block-editor-block-list__layout':
			{
				display: 'block',
				columns: 2,
				'> *': {
					breakInside: 'avoid-column',
					webkitColumnBreakInside: 'avoid',
					overflow: 'hidden',
				},
			},
	});

const getEditStyles = () =>
	css({
		'.supt-listAccordions__list': {
			gridColumn: '1/13 !important',
		},
	});

const getCustomStyles = () =>
	cssObj({
		'.supt-listAccordions': {
			marginTop: 30,
			[`@media (min-width: ${breakpoints.medium})`]: {
				marginTop: 0,
			},

			'.supt-listAccordions__list': {
				gap: '0px',
				display: 'initial',

				['@media (min-width: 768px)']: {
					gridColumn: '1 / span 12',
				},
			},
		},
	});

export { getStyles, getEditStyles, getEditGlobalStyles, getCustomStyles };
